module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/treatment_icon-7d642a8cc9c2aa19952ed0fac607b347.png";